module.exports = __webpack_public_path__ + "static/moderado-7dd410208f64cc7b94f10c0107a158eb.png";